<template>
<div>
    <section data-jarallax data-speed=".8" class="pt-12 pb-10 pt-md-15 pb-md-14" style="background-image: url(/assets/img/covers/cover-3.jpg)">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-8 col-lg-6">
                    <h1 class="display-3 fw-bold text-white" id="welcomeHeadingSource">
                        {{ $root.siteName }} will help you <br />
                        <span class="text-warning" data-typed='{"strings": ["get users and followers", "get posts and stories", "get likers", "get comments", "get hashtags", "get places", "get clips", "get highlights", "search music", "search hashtags"]}'></span>
                    </h1>
                    <p class="fs-lg text-white-80 mb-6">
                        We receive only verified data from social networks
                    </p>
                </div>
            </div> <!-- / .row -->
        </div> <!-- / .container -->
    </section>
    <section class="py-6 py-md-8 bg-warning">
        <div class="container">
            <div class="flickity-viewport-visible"
                 data-flickity='{"imagesLoaded": true, "initialIndex": 6, "pageDots": false, "prevNextButtons": false, "contain": true}'>
                <div class="col-12">
                    <strong>{{ $root.siteName }}</strong>, the world's largest API hub, is used by over four thousand developers to find, test and connect to some API<br>
                    — all with a single API key and dashboard!
                </div>
            </div>
        </div> <!-- / .container -->
    </section>
    <section class="pt-8 pb-4 pt-md-10 pb-md-6">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-10 text-center">
                    <h2>We provide a service capable of <span class="fw-bold text-primary-desat">withstanding huge loads</span></h2>
                    <p>
                        We use open APIs to perform distributed queries
                    </p>
                </div>
            </div>
        </div>
    </section>
    <section class="py-1 py-md-2">
        <Plans />
    </section>
    <section class="pt-6 pt-md-8">
        <div class="container pb-6 pb-md-8 border-bottom">
            <div class="row align-items-center" v-show="!$root.context.id">
                <div class="col-12 col-md">
                    <h3 class="mb-1">Register and start using our service!</h3>
                    <p class="fs-lg text-muted mb-6 mb-md-0">Fund up your account in your personal dashboard, get token and use any plan</p>
                </div>
                <div class="col-12 col-md-auto">
                    <div class="text-center text-md-start">
                        <router-link :to="{path: '/login'}" class="btn btn-primary shadow lift me-1">
                            Login <i class="fe fe-arrow-right d-none d-md-inline ms-3"></i>
                        </router-link>
                        <router-link :to="{path: '/registration'}" class="btn btn-primary-soft lift">
                            Registration
                        </router-link>
                    </div>
                </div>
            </div> <!-- / .row -->
        </div> <!-- / .container -->
    </section>
</div>
</template>

<script>
import Plans from './Plans'
export default {
    components: { Plans },
    data() {
        return {}
    },
    created() {
        if (this.$route.params && this.$route.params.promocode)
            localStorage.setItem("promocode", this.$route.params.promocode);
        if (location.search.indexOf("paymentId") != -1) {
            this.$router.replace({path: '/billing'})
        }
    }
}
</script>
